import { render, staticRenderFns } from "./GGroupEditValueCell.vue?vue&type=template&id=1ff4a192&scoped=true&"
import script from "./GGroupEditValueCell.vue?vue&type=script&lang=ts&"
export * from "./GGroupEditValueCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4a192",
  null
  
)

export default component.exports